import { SubscriptionErrorFragment } from "@saleor/fragments/types/SubscriptionErrorFragment";
import { commonMessages } from "@saleor/intl";
import { SubscriptionErrorCode } from "@saleor/types/globalTypes";
import { defineMessages, IntlShape } from "react-intl";

import commonErrorMessages from "./common";

const messages = defineMessages({
  alreadyExists: {
    defaultMessage: "A subscriber with this EMAIL already exists"
  },
  duplicatedInputItem: {
    defaultMessage: "Subscriber with these email already exists"
  },
  emailAlreadyTaken: {
    defaultMessage: "This email is already taken. Please provide another."
  }
});

function getSubscriptionErrorMessage(
  err: Omit<SubscriptionErrorFragment, "__typename"> | undefined,
  intl: IntlShape
): string {
  if (err) {
    switch (err.code) {
      case SubscriptionErrorCode.ALREADY_EXISTS:
        return intl.formatMessage(messages.alreadyExists);
      case SubscriptionErrorCode.DUPLICATED_INPUT_ITEM:
        return intl.formatMessage(messages.duplicatedInputItem);
      case SubscriptionErrorCode.GRAPHQL_ERROR:
        return intl.formatMessage(commonErrorMessages.graphqlError);
      case SubscriptionErrorCode.REQUIRED:
        return intl.formatMessage(commonMessages.requiredField);
      case SubscriptionErrorCode.INVALID:
        return intl.formatMessage(commonErrorMessages.invalid);
      case SubscriptionErrorCode.UNIQUE:
        return intl.formatMessage(messages.emailAlreadyTaken);
      default:
        return intl.formatMessage(commonErrorMessages.unknownError);
    }
  }

  return undefined;
}

export default getSubscriptionErrorMessage;
